export class Point {

  public x: number;
  public y: number;

}
